import { useEffect, useState } from "react";
import Agent from "../../../Network/Agent";

export default function DcConsum() {

    const [data, setData] = useState([]);

    const fetchData = async () => {
        Agent.MANAGEMENT_DASHBOARD.temperature_range().then((response) => {
            const dataValue = response.data.data;
            setData(dataValue);
        }).catch((error) => {
            console.error("Error fetching ACS power status:", error);
        });
    }

    useEffect(() => {

        fetchData();

    }, []);

    return (
        <>
            <div className="card">

                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true"><i class="fa-solid fa-temperature-half me-2" ></i>Temperature</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false"><i class="fa-solid fa-list me-2" ></i>Dc Consumption Status(kW)</button>
                    </li>

                </ul>

                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
                        <table className="table table-bordered text-center">
                            <tbody><tr>
                                <th style={{ fontSize: '12px' }}>Temperature range</th>
                                <th style={{ fontSize: '12px' }}>Site Count</th>
                            </tr>
                                {data?.temperature_counts &&
                                    Object.entries(data.temperature_counts).map(([range, count]) => (
                                        <tr key={range}>
                                            <td style={{ fontSize: '12px' }}>{range}</td>
                                            <td style={{ fontSize: '12px' }}>{count}</td>
                                        </tr>
                                    ))}

                            </tbody>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">
                        <table className="table table-bordered text-center">
                            <tbody><tr>
                                <th style={{ fontSize: '12px' }}>Consumption(kW)</th>
                                <th style={{ fontSize: '12px' }}>Site Count</th>
                                <th style={{ fontSize: '12px' }}>BL</th>
                                <th style={{ fontSize: '12px' }}>Robi</th>
                                <th style={{ fontSize: '12px' }}>GP</th>
                            </tr>
                                {data?.slab_counts &&
                                    Object.entries(data.slab_counts)
                                        .sort(([aKey], [bKey]) => {
                                            const aNum = parseFloat(aKey);
                                            const bNum = parseFloat(bKey);

                                            if (isNaN(aNum)) return -1; // keep ">4" on top
                                            if (isNaN(bNum)) return 1;

                                            return bNum - aNum; // descending order
                                        })
                                        .map(([key, count]) => (
                                            <tr key={key}>
                                                <td style={{ fontSize: '12px' }}>{key}</td>
                                                <td style={{ fontSize: '12px' }}>{count}</td>
                                                <td style={{ fontSize: '12px' }}>
                                                    {data.operators?.[key]?.['1'] || 0}
                                                </td>
                                                <td style={{ fontSize: '12px' }}>
                                                    {data.operators?.[key]?.['3'] || 0}
                                                </td>
                                                <td style={{ fontSize: '12px' }}>
                                                    {data.operators?.[key]?.['4'] || 0}
                                                </td>
                                            </tr>
                                        ))}

                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </>
    );
}